<template>
  <transition
    name="fade-content"
    appear
    mode="out-in"
  >
    <div class="landing-page-inner landing-page-inner_partner">
      <div class="landing-page__container landing-page__container_expand">
        <div class="partner">
          <h2 class="landing-page__title">
            {{ $t('landingPage.partnerPage.title') }}
          </h2>
          <div class="partner__desc">
            {{ $t('landingPage.partnerPage.description') }}
          </div>
          <div class="advantages">
            <div
              v-for="item in advantages"
              :key="item.id"
              class="advantages__item"
            >
              <div class="advantages__item-icon">
                <div class="advantages__item-circle">
                  <i :class="item.icon"></i>
                </div>
              </div>
              <div class="advantages__item-info">
                <div class="advantages__item-text">
                  {{ $t(item.text) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partner-buttons">
          <a
            class="landing-page__button landing-page__button_secondary partner-buttons__link"
            rel="noopener noreferrer"
            aria-label="Upper Business Partner"
            @click="openNewWindow()"
          >
            {{ $t('landingPage.partnerPage.buttonTextPartner') }}
          </a>
          <button
            class="landing-page__button landing-page__button_transparent"
            @click="proceedToSelection()"
          >
            {{ $t('landingPage.partnerPage.buttonTextRegister') }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import advantages from '@/constants/landing/advantages';

export default {
  name: 'Partner',
  data: () => ({
    advantages,
  }),
  methods: {
    proceedToSelection() {
      this.$router.push({
        name: `selectionService-${this.$i18n.locale}`,
      });
    },
    openNewWindow() {
      const link = 'https://docs.google.com/forms/d/1ZH3c9neQJ4YlGd21HhRdcTUlIFvC6SEjjpETUFU6isM/edit';
      window.open(link);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../sass/mixins";

 .landing-page {
   &__button {
     &_transparent {
       transition: all .15s ease-in;

       &:hover {
         background: $color-white;
         color: $color-dodger-blue;
         opacity: 1;
       }
     }
   }
 }

 .partner {
   padding-top: 292px;

   @include desktop-small {
     padding-top: 150px;
   }

   @include only-tablet-landscape {
     padding-top: 138px;
   }

   @include mobile {
     display: flex;
     flex-direction: column;
     align-items: center;
     max-width: 500px;
     margin: 0 auto;
   }

   @include tablet-portrait {
     padding-top: 200px;
   }

   @include mobile {
     padding-top: 200px;
   }

   &-buttons {
     display: flex;
     justify-content: center;
     margin-top: 50px;

     &__link {
       text-decoration: none;
     }

     @include mobile {
       max-width: 320px;
       margin: 50px auto 0;
     }

     @include tablet-portrait {
       margin-top: 25px;
     }

     @include mobile {
       flex-direction: column;
     }

     a + button {
       margin-left: 16px;

       @include mobile {
         margin-left: 0;
         margin-top: 12px;
       }
     }
   }

   .landing-page__title {
     text-align: center;
     margin-bottom: 5px;

     @include mobile {
       text-align: left;
     }
   }

   &__desc {
     font: $font-size-landing-medium $font-landing-global;
     max-width: 752px;
     margin: 0 auto;
     text-align: center;
     line-height: 1.5;

     @include mobile {
       text-align: left;
       font-size: $font-size-landing-sm;
       margin-top: 11px;
     }
   }

   .advantages {
     display: flex;
     justify-content: space-between;
     max-width: 1445px;
     width: 100%;
     margin: 50px auto 0;

     @include tablet-landscape {
       flex-wrap: wrap;
       justify-content: space-around;
     }

     @include mobile {
       margin-top: 47px;
       padding-left: 7px;
     }

     &__item {
       display: flex;
       max-width: 375px;
       align-items: center;

       @include tablet-old {
         &:last-child {
           margin-top: 30px;

           @include tablet-portrait {
             margin-top: 0;
           }

           @include mobile {
             margin-bottom: 15px;
           }
         }
       }

       @include tablet-portrait {
         margin-bottom: 30px;
       }

       @include mobile {
         margin-bottom: 47px;
       }

       &-title {
         font: $font-size-landing-sm $font-landing-heavy;
         margin-bottom: 9px;
       }

       &-text {
         font: $font-size-landing-sm $font-landing-global;
         line-height: 1.5;
       }

       &-icon {
         position: relative;

         &:after {
           position: absolute;
           content: '';
           width: 190px;
           height: 65px;
           background: rgba($color-white, .1);
           left: -10px;
           top: -6px;
         }

         i {
           font-size: $font-size-icon-ml;
           color: $color-dodger-blue;

           &.ub-icon-chats {
             position: relative;
             right: 1px;
             top: 2px;
           }
         }
       }

       &-circle {
         width: 48px;
         height: 48px;
         border-radius: 50%;
         background: $color-white;
         display: flex;
         align-items: center;
         justify-content: center;
         margin-right: 14px;
       }
     }
   }
 }

 @include mobile {
   .partner {
     &__desc {
       margin-left: 0;
       margin-right: 0;
     }

     .advantages {
       justify-content: flex-start;
     }
   }
 }
</style>
